import "./search-btn.scss";

let search = document.getElementById('search-mobile');
let searchBtn = document.getElementById('search-btn');

searchBtn.addEventListener('click', function () {
    search.classList.toggle('hidden');
 });